<template>
	<div class="markete-manage-row">
		<div class="filters-container" :style="collapse ? 'height: 50px' : ''">
			<div class="input-box">
				<span>活动名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入活动名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productName"
					placeholder="请输入商品名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>适用门店：</span>
				<el-select
					size="mini"
					class="name-input"
					v-model="shopNameIds"
					filterable
					multiple
					collapse-tags
					placeholder="请选择门店名称">
					<!-- <el-option label="全部" value=""></el-option> -->
					<template v-for="item in shopList">
						<el-option
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box">
				<span>活动状态：</span>
				<el-select v-model="disabledFlag" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>使用状态：</span>
				<el-select v-model="discountState" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="已生效"></el-option>
					<el-option :value="1" label="未生效"></el-option>
					<el-option :value="2" label="已失效"></el-option>
				</el-select>
			</div>
			<div class="time-box">
				<span>活动日期：</span>
				<el-date-picker
					v-model="dateValue"
					:clearable="false"
					:unlink-panels='true'
					class="time-input"
					size="mini"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm:ss'
					value-format='yyyy-MM-dd HH:mm:ss'>
				</el-date-picker>
			</div>
		</div>
		<div class="markete-manage-btn">
			<el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
            <el-button
				type="primary"
				class="btn fx-btn"
				size="mini"
				@click="onSearch">查询</el-button>
			<el-button
				class="btn fx-btn"
				size="mini"
                plain
				@click="clearing">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {
		isMuti: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			collapse: false,
			dateValue: [],
			name: '',
			productName: '',
			discountState: -1,
			disabledFlag: -1,
			shopList: [],
			shopNameIds: []
		}
	},
	created () {
		this.getShopList()
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		clearing () {
			this.dateValue = []
			this.name = ''
			this.productName = ''
			this.discountState = -1
			this.disabledFlag = -1
			this.shopNameIds = []
			this.onSearch()
		},
		onSearch () {
			let params = {
				name: this.name,
				productName: this.productName,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				dateValue: this.dateValue,
				discountState: this.discountState,
				disabledFlag: this.disabledFlag,
				page: 1,
				size: 20
			}
			if (this.isMuti) {
				params.type = 5
			}
			if (this.shopNameIds.length) {
				params.shopIds = this.shopNameIds
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/list`,
				data: params
			}).then(res => {
				// console.log(res)
				this.$emit('getTableData', res)
				this.$emit('getParamsData', params)
			}).catch(() => {
				this.$emit('getParamsData', params)
			})
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
				console.log(res)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.markete-manage-row {
	display: flex;
	justify-content: space-between
	padding: 10px 0;
	width :100%;
	line-height :50px;
	border-bottom 1px solid #dce2fd;
	box-sizing: border-box
	.filters-container {
		display flex
		flex-wrap: wrap;
		overflow: hidden;
		flex: 1
		.time-box {
			display flex
			width: 420px
			margin-left: 20px;
			align-items: center;
			span {
				margin-right: 10px
			}
			.time-input {
				flex: 1
			}
		}
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.name-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
	.markete-manage-btn {
		width: 200px;
		flex-shrink: 0
	}
}
</style>
